import QuestionBankService from '@/services/questionBank.service';
import axios from "axios";

export const questionBankModule = {
    namespaced: true,
    state: {
        labels: new Map(),
        label: {},
        questions: new Map(),
        reviewers: new Map(),
        auditLogs: new Map(),
        requests: [],
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async listLabels({commit, dispatch}, {query = '', page = '1', count = '5'}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listLabels");

            return await QuestionBankService.listLabels(axiosSource, query, page, count).then(
                async data => {
                    commit('updateLabelsList', data);
                    await dispatch('clearRequest', "listLabels");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createLabel({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createLabel");
            return QuestionBankService.createLabel(axiosSource, data).then(
                async data => {
                    commit('insertLabel', data)
                    await dispatch('clearRequest', "createLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateLabel({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateLabel");
            return QuestionBankService.updateLabel(axiosSource, data).then(
                async data => {
                    commit('updateLabelData', data)
                    await dispatch('clearRequest', "updateLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteLabel({commit, dispatch}, labelId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteLabel");
            return QuestionBankService.deleteLabel(axiosSource, labelId).then(
                async data => {
                    commit('removeLabelFromList', labelId)
                    await dispatch('clearRequest', "deleteLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listQuestions({commit, dispatch}, {query = '', page = '1', count = '5'}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listQuestions");

            return await QuestionBankService.listQuestions(axiosSource, query, page, count).then(
                async data => {
                    commit('updateQuestionsList', data);
                    await dispatch('clearRequest', "listQuestions");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createQuestion({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createQuestion");
            return QuestionBankService.createQuestion(axiosSource, data).then(
                async data => {
                    commit('insertQuestion', data)
                    await dispatch('clearRequest', "createQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async importQuestion({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "copyExam");
            return QuestionBankService.importQuestion(axiosSource, data).then(
                async data => {
                    commit('appendQuestionsList', data)
                    await dispatch('clearRequest', "copyExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateQuestion({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateQuestion");
            return QuestionBankService.updateQuestion(axiosSource, data).then(
                async data => {
                    commit('updateQuestionData', data)
                    await dispatch('clearRequest', "updateQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteQuestion({commit, dispatch}, questionId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteQuestion");
            return QuestionBankService.deleteQuestion(axiosSource, questionId).then(
                async data => {
                    commit('removeQuestionFromList', questionId)
                    await dispatch('clearRequest', "deleteQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listReviewers({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listReviewers");
            return QuestionBankService.listReviewers(axiosSource).then(
                async data => {
                    commit('updateReviewersList', data);
                    await dispatch('clearRequest', "listReviewers");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createReviewer({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createReviewer");
            return QuestionBankService.createReviewer(axiosSource, data).then(
                async data => {
                    commit('insertReviewer', data)
                    await dispatch('clearRequest', "createReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateReviewer({commit, dispatch}, {reviewerId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateReviewer");
            return QuestionBankService.updateReviewer(axiosSource, reviewerId, data).then(
                async data => {
                    commit('updateReviewerData', data)
                    await dispatch('clearRequest', "updateReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteReviewer({commit, dispatch}, reviewerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteReviewer");
            return QuestionBankService.deleteReviewer(axiosSource, reviewerId).then(
                async data => {
                    commit('removeReviewerFromList', reviewerId)
                    await dispatch('clearRequest', "deleteReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listBankLogs({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listBankLogs");
            return QuestionBankService.listBankLogs(axiosSource).then(
                async data => {
                    commit('updateBankLogList', data);
                    await dispatch('clearRequest', "listBankLogs");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listReviewerLogs({commit, dispatch}, reviewerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listReviewerLogs");
            return QuestionBankService.listReviewerLogs(axiosSource, reviewerId).then(
                async data => {
                    commit('updateReviewerLogList', data);
                    await dispatch('clearRequest', "listReviewerLogs");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateLabelsList(state, data) {
            state.labels = new Map()
            for (const entity of data.items) {
                state.labels.set(entity.id, entity)
            }
        },
        insertLabel(state, data) {
            state.labels.set(data.id, data)
        },
        updateLabelData(state, data) {
            state.labels.set(data.id, data)
        },
        removeLabelFromList(state, labelId) {
            state.labels.delete(labelId)
        },
        updateQuestionsList(state, data) {
            state.questions = new Map()
            for (const entity of data.items) {
                state.questions.set(entity.id, entity)
            }
        },
        appendQuestionsList(state, data) {
            for (const entity of data) {
                state.questions.set(entity.id, entity)
            }
        },
        insertQuestion(state, data) {
            state.questions.set(data.id, data)
        },
        updateQuestionData(state, data) {
            state.questions.set(data.id, data)
        },
        removeQuestionFromList(state, questionId) {
            state.questions.delete(questionId)
        },
        updateReviewersList(state, data) {
            state.reviewers = new Map()
            for (const entity of data) {
                state.reviewers.set(entity.user.id, entity)
            }
        },
        insertReviewer(state, data) {
            state.reviewers.set(data.user.id, data)
        },
        updateReviewerData(state, data) {
            state.reviewers.set(data.user.id, data)
        },
        removeReviewerFromList(state, userId) {
            state.reviewers.delete(userId)
        },
        updateReviewerLogList(state, data) {
            state.auditLogs = new Map()
            for (const entity of data) {
                state.auditLogs.set(entity.objcet_id, entity)
            }
        },
        updateBankLogList(state, data) {
            state.auditLogs = new Map()
            for (const entity of data) {
                state.auditLogs.set(entity.objcet_id, entity)
            }
        },
    }
};